export const tabsOptionsAnswers = (answers, combination, questionType) => [{
  eventKey: 'answers',
  title: 'Respuestas',
  content: answers
},{
  eventKey: 'combination',
  title: 'Combinaciones',
  content: combination,
  disabled: questionType !== 'Matriz'
}];